module.exports = __webpack_public_path__ + "static/media/invite-customer.03af0263.svg";